export interface EquivalentResourcesRate {
  icon: string;
  rate: number;
  regionMetricRate?: {
    metric: number;
    imperial: number;
  };
  title?: string;
  message: string;
}

const CAR_KG = <EquivalentResourcesRate>{
  icon: "car",
  rate: 8.620689655,
  regionMetricRate: {
    metric: 1,
    imperial: 1,
  },
  title: "km",
  message: "Driven by an average new passenger car",
};

const COAL_KG = <EquivalentResourcesRate>{
  icon: "fire",
  rate: 1.962114133,
  regionMetricRate: {
    metric: 1,
    imperial: 1,
  },
  title: "kg",
  message: "Of coal burned",
};

const SMARTPHONES_CHARGED = <EquivalentResourcesRate>{
  icon: "battery",
  rate: 121.654501216545,
  message: "Smartphones charged",
};

const BAGS_RECYCLED = <EquivalentResourcesRate>{
  icon: "recycle",
  rate: 0.043290043,
  message: "Bags of household waste recycled instead of dumped",
};

const TREE_GROWN = <EquivalentResourcesRate>{
  icon: "seed",
  rate: 0.016666667,
  message: "Tree seedlings grown for 10 years",
};
export const EQUIVALENT_EMISSIONS = [CAR_KG, COAL_KG, SMARTPHONES_CHARGED];
export const EQUIVALENT_OFFSET = [BAGS_RECYCLED, TREE_GROWN];
